var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./gallery-list.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4b34af10\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./gallery-list.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/gallery/components/gallery-list/gallery-list.vue
// module id = 255
// module chunks = 0